import '@babel/polyfill'
import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import MyHeader from './components/header'
import MyFooter from './components/footer'
import TimeArticle from './components/time-article'
import NormalArticle from './components/normal-article'
import ArticleTimeAfter from './components/article-timeafter'
import ImgText from './components/img-text'
import AutoScroll from './components/auto-scroll'
import Editor from "@/components/Editor"
import MyContainer from '@/components/my-container'
Vue.component('Editor', Editor)
import 'quill/dist/quill.core.css';
// 根据你选择的主题引入相应的样式
import 'quill/dist/quill.snow.css'; // Snow主题样式
// 或者
import 'quill/dist/quill.bubble.css'; // Bubble主题样式

Vue.component('MyHeader', MyHeader)
Vue.component('MyContainer', MyContainer)
Vue.component('MyFooter', MyFooter)
Vue.component('TimeArticle', TimeArticle)
Vue.component('NormalArticle', NormalArticle)
Vue.component('ImgText', ImgText)
Vue.component('AutoScroll', AutoScroll)
Vue.component('ArticleTimeAfter', ArticleTimeAfter)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
